import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { UsersCreatedConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
    selector: 'users-created-details',
    templateUrl: './users-created-details.component.html',
    standalone: false,
})
export class UsersCreatedDetailsComponent
  extends BaseDetailsLogic<UsersCreatedConfig>
  implements OnInit, OnDestroy
{

  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, UsersCreatedConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
      this.detectSettingsChange();
      this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod: 'Pick a time period to see which users were created during that time. For example, you can look at users created in the last week, month, or year. This helps you understand when new users are joining.'
    };
  }
}
